export function getPronoun(gender) {
	if (gender === 'm') {
		return 'Er';
	} else if (gender === 'f') {
		return 'Sie';
	}
	return 'Dey';
}
